(() => {
  if (window.ClearanceCommerce) return;
  window.ClearanceCommerce = true;

  const moneyButtonState = new WeakMap();

  function sectionRoot(el) {
    return el.closest('[id^="ConditionShop-"], [id^="FeaturedDeals-"]');
  }

  async function addToCart(button) {
    if (button.disabled || button.dataset.loading === 'true') return;
    const variantId = Number(button.dataset.variant || button.dataset.add);
    if (!variantId) return;

    button.dataset.loading = 'true';
    const original = button.innerHTML;
    moneyButtonState.set(button, original);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';

    const drawer = document.querySelector('cart-drawer');
    const sections = drawer?.getSectionsToRender?.().map((section) => section.id) || ['cart-icon-bubble'];

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections,
          sections_url: window.location.pathname
        })
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add item');

      button.textContent = 'Added';
      if (drawer?.renderContents && state.sections) {
        drawer.renderContents(state);
      } else {
        const cart = await fetch(window.routes?.cart_url ? window.routes.cart_url + '.js' : '/cart.js').then((r) => r.json());
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((el) => {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      }

      if (window.publish && window.PUB_SUB_EVENTS?.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'clearance-product-card', productVariantId: variantId, cartData: state });
      }
    } catch (error) {
      button.textContent = error.message || 'Try again';
    } finally {
      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.innerHTML = moneyButtonState.get(button) || original;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        delete button.dataset.loading;
      }, 1200);
    }
  }

  function activateCondition(tab) {
    const root = tab.closest('[id^="ConditionShop-"]');
    if (!root) return;
    const key = tab.dataset.tab;
    root.querySelectorAll('[data-tab]').forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.tabIndex = active ? 0 : -1;
    });
    let activePanel = null;
    root.querySelectorAll('[data-panel]').forEach((panel) => {
      const active = panel.dataset.panel === key;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      panel.style.display = active ? 'block' : 'none';
      if (active) activePanel = panel;
    });
    activePanel?.querySelector('[data-track]')?.scrollTo({ left: 0, behavior: 'auto' });
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }

  function initializeConditions(scope = document) {
    scope.querySelectorAll?.('[id^="ConditionShop-"]').forEach((root) => {
      const selected = root.querySelector('[data-tab][aria-selected="true"]') || root.querySelector('[data-tab]');
      if (selected) activateCondition(selected);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeConditions(), { once: true });
  else initializeConditions();
  document.addEventListener('shopify:section:load', (event) => initializeConditions(event.target));

  document.addEventListener('click', (event) => {
    const add = event.target.closest('.cs-cart[data-add], .fd-cart[data-add]');
    if (add) {
      event.preventDefault();
      event.stopPropagation();
      addToCart(add);
      return;
    }
    const tab = event.target.closest('[id^="ConditionShop-"] [data-tab]');
    if (tab) {
      event.preventDefault();
      activateCondition(tab);
    }
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest?.('[id^="ConditionShop-"] [data-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-tab]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = tabs.length - 1;
    event.preventDefault();
    tabs[index].focus();
    activateCondition(tabs[index]);
  });
})();